import { apiDiscountCodes } from './apiDiscountCodes'
import { apiB2bClients } from './apiB2bClients'

const apiDiscountCodesGroup = {
	...apiDiscountCodes,
	...apiB2bClients,
}

export { apiDiscountCodesGroup }
